import React from 'react';
import { Link } from 'react-router-dom';

import PaymentMethodChannelList from './PaymentMethodChannelList';

import Card from 'crm/elements/common/Card';

function PaymentMethodChannelPage() {
    return (
        <Card title="Payment Method Channels">
            <Link className="btn btn-primary btn-sm mb-3" to="/payment_method_channels/create">
                Create new Payment Method Channel
            </Link>
            <PaymentMethodChannelList />
        </Card>
    );
}

export default PaymentMethodChannelPage;
